import React from 'react';
import { NavMenu } from './NavMenu';
import ScrollToTop from './ScrollToTop';
import typography from '../utils/typography';
import { TypographyStyle } from 'react-typography';

export const Layout = ({ children }) => {
    return (
        <React.Fragment>
            <TypographyStyle typography={typography} />
            <NavMenu />
            {children}
            <ScrollToTop />
        </React.Fragment>
    );
};
